import { render, staticRenderFns } from "./StandingApproval.vue?vue&type=template&id=2f7fcbaf"
import script from "./StandingApproval.vue?vue&type=script&lang=js"
export * from "./StandingApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f7fcbaf')) {
      api.createRecord('2f7fcbaf', component.options)
    } else {
      api.reload('2f7fcbaf', component.options)
    }
    module.hot.accept("./StandingApproval.vue?vue&type=template&id=2f7fcbaf", function () {
      api.rerender('2f7fcbaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/admin/StandingApproval.vue"
export default component.exports